export interface GetAcceptOrdersRequest {
  orderId: number
  isbn: string
  bibliographyRealIds: number[]
  branchCode: string
  traderCode: string
  donorCode: string
  buyDepartmentCode: string
  orderDateFrom: string
  orderDateTo: string
  checkStatus: boolean
}

export function GetAcceptOrdersRequestToJSON(
  value: GetAcceptOrdersRequest
): any {
  return {
    order_id: value.orderId !== 0 ? value.orderId : undefined,
    isbn: value.isbn !== '' ? value.isbn : undefined,
    bibliography_real_ids:
      value.bibliographyRealIds.length > 0
        ? value.bibliographyRealIds
        : undefined,
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    buy_department_code:
      value.buyDepartmentCode !== '' ? value.buyDepartmentCode : undefined,
    order_date_from:
      value.orderDateFrom !== '' ? value.orderDateFrom : undefined,
    order_date_to: value.orderDateTo !== '' ? value.orderDateTo : undefined,
    check_status: value.checkStatus ?? undefined
  }
}
